var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 38,
    height: 38,
    rx: 17,
    fill: "#071E3B",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.5 27.5H14.5C11.5 27.5 9.5 26 9.5 22.5V15.5C9.5 12 11.5 10.5 14.5 10.5H24.5C27.5 10.5 29.5 12 29.5 15.5V22.5C29.5 26 27.5 27.5 24.5 27.5Z",
    fill: "#145DA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5008 19.87C18.6608 19.87 17.8108 19.61 17.1608 19.08L14.0308 16.58C13.7108 16.32 13.6508 15.85 13.9108 15.53C14.1708 15.21 14.6408 15.15 14.9608 15.41L18.0908 17.91C18.8508 18.52 20.1407 18.52 20.9007 17.91L24.0308 15.41C24.3508 15.15 24.8308 15.2 25.0808 15.53C25.3408 15.85 25.2908 16.33 24.9608 16.58L21.8308 19.08C21.1908 19.61 20.3408 19.87 19.5008 19.87Z",
    fill: "#145DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.da2c1bd5cf885e674ea59043ddded301.svg";
export { ForwardRef as ReactComponent };